import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { LoginGuard, ActionGuard } from '../../core/_infrastructure/classes/guards/main.guard';
import { InformeExportacionesComponent } from './informeexportaciones/informe-exportaciones.component';
import { InformeImportacionesComponent } from './informeimportaciones/informe-importaciones.component';
import { InformeInspeccionesComponent } from './informeinspecciones/informe-inspecciones.component';
import { InformeInspeccionesExportacionComponent } from './informeinspeccionesexportacion/informe-inspeccionesexportacion.component';
import { InformesListComponent } from './informes-list.component';
import { InformeTasasComponent } from './informetasas/informe-tasas.component';
import { InformeTasasExportacionComponent } from './informetasasexportacion/informe-tasasexportacion.component';

const InformesRoutes: Routes = [
    {
        path: 'global/informes',
        data: {
            breadcrumb: 'Informes',
            menu0: 'GLOBAL',
        },
        children: [
            {
                path: '',
                component: InformesListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Informes',
                    actionCode: EnumCodigosTwTcAcciones.INFORMES_GENERALES,
                },
            },
            {
                path: 'informeimportaciones',
                component: InformeImportacionesComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Informe Estadístico de Importaciones',
                    actionCode: EnumCodigosTwTcAcciones.INFORMES_GENERALES,
                },
            },
            {
                path: 'informeexportaciones',
                component: InformeExportacionesComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Informe Estadístico de Exportaciones',
                    actionCode: EnumCodigosTwTcAcciones.INFORMES_GENERALES,
                },
            },

            {
                path: 'informetasas',
                component: InformeTasasComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Informe General Tasas de Importaciones',
                    actionCode: EnumCodigosTwTcAcciones.INFORMES_GENERALES,
                },
            },
            {
                path: 'informetasasexportacion',
                component: InformeTasasExportacionComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Informe General Tasas de Exportaciones',
                    actionCode: EnumCodigosTwTcAcciones.INFORMES_GENERALES,
                },
            },
            {
                path: 'informeinspecciones',
                component: InformeInspeccionesComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Informe Estadístico de Inspecciones Importaciones',
                    actionCode: EnumCodigosTwTcAcciones.INFORMES_GENERALES,
                },
            },
            {
                path: 'informeinspeccionesexportacion',
                component: InformeInspeccionesExportacionComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Informe Estadístico de Inspecciones Exportaciones',
                    actionCode: EnumCodigosTwTcAcciones.INFORMES_GENERALES,
                },
            },
            //{
            //    path: 'informebusqueda',
            //    component: InformeBusquedaComponent,
            //    canActivate: [LoginGuard(), ActionGuard()],
            //    data: {
            //        breadcrumb: 'Informe General de Búsqueda',
            //        actionCode: EnumCodigosTwTcAcciones.INFORMES_GENERALES
            //    },
            //},
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(InformesRoutes)],
    exports: [RouterModule],
})
export class InformesRoutingModule {}
